import { createReducer } from '@reduxjs/toolkit';

import postArticlesTheme, { clearPostThemeData } from '../../thunks/articles/postArticlesTheme';

const initialState = {
  loading: false,
  error: '',
  data: null,
};

const postArticlesThemeReducer = createReducer(initialState, {
  [postArticlesTheme.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [postArticlesTheme.fulfilled]: (state, { payload }) => ({
    ...state,
    loading: false,
    data: payload,
  }),
  [clearPostThemeData]: () => initialState,
  [postArticlesTheme.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
});

export default postArticlesThemeReducer;
